import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const VENDOR_SKU_CODE_DUPLICATED_ERROR_CODE = 'VENDOR_SKU_CODE_DUPLICATED';

export const VENDOR_SKU_DUPLICATE_MESSAGE_KEY =
  'vendor.messages.error.vendor_sku_code_already_exists';

interface VendorSkuErrorRule {
  errorCode?: string;
  messagePatterns: string[];
  key: string;
}

const VENDOR_SKU_ERROR_RULES: VendorSkuErrorRule[] = [
  {
    errorCode: VENDOR_SKU_CODE_DUPLICATED_ERROR_CODE,
    messagePatterns: ['Vendor SKU code already exists'],
    key: VENDOR_SKU_DUPLICATE_MESSAGE_KEY,
  },
  {
    messagePatterns: ['Vendor is INACTIVE'],
    key: 'vendor.messages.error.vendor_inactive_cannot_manage_sku',
  },
  {
    messagePatterns: ['Not found Vendor SKU'],
    key: 'vendor.messages.error.vendor_sku_not_found',
  },
  {
    messagePatterns: ['Not found Vendor'],
    key: 'vendor.messages.error.vendor_not_found',
  },
];

// Generated API clients send a wildcard Accept header, so Angular uses responseType 'blob' and an
// error body arrives as an unreadable Blob. Without this the caller only sees the raw
// "Http failure response ..." text instead of the backend ErrorResponse.
export function parseBlobHttpError<T>() {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      catchError((error) =>
        error?.error instanceof Blob
          ? from((error.error as Blob).text()).pipe(
              switchMap((text) => throwError(() => withParsedBody(error, text))),
            )
          : throwError(() => error),
      ),
    );
}

function withParsedBody(error: any, text: string): any {
  try {
    return { ...error, error: text ? JSON.parse(text) : null };
  } catch {
    return error;
  }
}

/**
 * Maps a backend ErrorResponse onto a translation key. Matches errorCode first and falls back to
 * the raw English message, which is all older backend builds return.
 */
export function resolveVendorSkuErrorKey(error: any): string | null {
  const errorCode = error?.error?.errorCode;
  const message = String(error?.error?.message ?? '');

  const rule = VENDOR_SKU_ERROR_RULES.find(
    (candidate) =>
      (candidate.errorCode && candidate.errorCode === errorCode) ||
      candidate.messagePatterns.some((pattern) => message.includes(pattern)),
  );

  return rule?.key ?? null;
}
